import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getReduxActionErrorMessage, isReduxThunkPendingAction, isReduxThunkRejectedAction } from '../core/utils';

import { ApiGatewayUrl } from "../appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from "../core/rest";
import { STATUS_TYPES } from '../core/constants';
import { getTreeviewDataFormat } from '../slices/shared/getTreeviewDataFormat';

const SLICE_NAME = "liveviewCamera";

export const getACLCamerasByUser = createAsyncThunk(
    "liveviewCamera/getCameras",
    async () => {
        try {
            const response = await Rest.get(ApiGatewayUrl + '/videosensors');
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);

export const getCamerasByFilter = createAsyncThunk(
    "liveviewCamera/getCamerasByFilter",
    async (request) => {
        try {
            const response = await Rest.get(
                ApiGatewayUrl + "/liveview/filter?filterText=" + JSON.stringify(request.cameraName)
                + "&access=" + request.access +
                "&noAccess=" + request.noAccess +
                "&ptzType=" + request.ptzType +
                "&staticType=" + request.staticType
            );
            let result = { data: response.data, cameraName: request.cameraName }
            return result;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);
export const liveviewCameraSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        treeViewCameras: [],
        cameras: [],
        defaultExpanded: [],
        isLoading: false,
        searchText: '',
    },
    extraReducers: (builder) => {
        builder
            .addCase(getACLCamerasByUser.fulfilled, (state, action) => {
                let { agencyExpand, vgpExpanded, data } = getTreeviewDataFormat(action.payload);
                return {
                    ...state,
                    cameras: action.payload, /*flat data for override acl when open preset */
                    treeViewCameras: data,
                    defaultExpanded: [...agencyExpand, ...vgpExpanded],
                    isLoading: false
                };
            })
            .addCase(getCamerasByFilter.fulfilled, (state, action) => {
                let { agencyExpand, vgpExpanded, data } = getTreeviewDataFormat(action.payload.data);
                return {
                    ...state,
                    cameras: action.payload.data, /*flat data for override acl when open preset */
                    searchText: action.payload.cameraName,
                    treeViewCameras: data,
                    defaultExpanded: [...agencyExpand, ...vgpExpanded],
                    isLoading: false
                };
            })

            //handle pending actions.
            .addMatcher((action) => isReduxThunkPendingAction(SLICE_NAME, action.type), (state) => {
                return { ...state, isLoading: true, errorMessage: "" };
            })

            //handle error action
            .addMatcher((action) => isReduxThunkRejectedAction(SLICE_NAME, action.type), (state, action) => {
                if (action.error && action.error.message === "Aborted") {
                    return {
                        ...state,
                        isLoading: false,
                        statusType: "",
                        actionType: action.type?.split("/")[1],
                        errorMessage: "",
                    };
                } else {
                    return {
                        ...state,
                        isLoading: false,
                        actionType: action.type?.split("/")[1],
                        statusType: STATUS_TYPES.rejected,
                        errorMessage: getReduxActionErrorMessage(action)
                    };
                }
            })
    }

});

export const liveviewCameraActions = liveviewCameraSlice.actions;
export const liveviewCameraState = (state) => state.liveviewCamera;
export default liveviewCameraSlice.reducer;
